@for (segment of segments(); track $index) {
  @if (segment.kind === 'markdown') {
    <div
      [innerHTML]="
        segment.markdown
          | markdownRendering
          | crmCitationRef: records() : streaming()
          | entityKeyRef
          | webSearchRef: citations()
          | webSourceRef: sources()
          | safeHtml
      "
    ></div>
  } @else if (segment.widget.kind === 'chart') {
    <ai-answer-chart [chart]="segment.widget"></ai-answer-chart>
  } @else if (segment.widget.kind === 'cards') {
    <ai-answer-card [cardGroup]="segment.widget"></ai-answer-card>
  } @else if (segment.widget.kind === 'timeline') {
    <ai-answer-timeline [timeline]="segment.widget"></ai-answer-timeline>
  } @else if (segment.widget.kind === 'stats') {
    <ai-answer-stats [statGroup]="segment.widget"></ai-answer-stats>
  } @else if (segment.widget.kind === 'stack') {
    <ai-answer-stack [stack]="segment.widget"></ai-answer-stack>
  } @else if (segment.widget.kind === 'profile') {
    <ai-answer-profile [profile]="segment.widget"></ai-answer-profile>
  } @else if (segment.widget.kind === 'list') {
    <ai-answer-list [list]="segment.widget"></ai-answer-list>
  } @else if (segment.widget.kind === 'facts') {
    <ai-answer-facts [factList]="segment.widget"></ai-answer-facts>
  } @else if (segment.widget.kind === 'table') {
    <ai-answer-table [table]="segment.widget"></ai-answer-table>
  } @else if (segment.widget.kind === 'sources') {
    <ai-answer-sources [sources]="segment.widget"></ai-answer-sources>
  } @else if (segment.widget.kind === 'actions') {
    <ai-answer-actions
      [actions]="segment.widget"
      [source]="segment.source"
      [threadId]="threadId()"
    ></ai-answer-actions>
  } @else if (segment.widget.kind === 'chiplist') {
    <div class="my-3">
      <ai-answer-chip-list [chipList]="segment.widget"></ai-answer-chip-list>
    </div>
  }
}

@if (followUpBlock(); as followUps) {
  <ai-answer-follow-ups
    [followUps]="followUps"
    (asked)="followUpAsked.emit($event)"
  ></ai-answer-follow-ups>
}

<!-- One card for the whole answer, over the chip the pointer or the focus is on. It is fixed to
     the viewport, so a scrolling conversation never clips it, and it closes with the chip gone. -->
@if (card(); as card) {
  <kendo-popup
    [anchor]="card.anchor"
    [anchorAlign]="{ horizontal: 'left', vertical: 'bottom' }"
    [popupAlign]="{ horizontal: 'left', vertical: 'top' }"
    [collision]="{ horizontal: 'fit', vertical: 'flip' }"
    [margin]="{ horizontal: 0, vertical: 4 }"
    [animate]="false"
    (anchorViewportLeave)="closeCard()"
  >
    <div class="crm-citation-popup">
      <ai-crm-citation-card
        [citation]="card.citation"
        [record]="cardRecord()"
        (opened)="openRecord(card.anchor)"
      ></ai-crm-citation-card>
    </div>
  </kendo-popup>
}
